import { AnalyticsEvent } from '../models';

export class PageNotFoundEvent implements AnalyticsEvent {
    name = 'PageNotFoundEvent';
}